import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Button from '../Button';

const propTypes = {
  dismissOrder: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

const defaultProps = {
  isLoading: false,
};

const CancelDeliverOrder = ({ isLoading, dismissOrder }) => {
  return (
    <form
      onSubmit={dismissOrder}
      className="OrderDetailsLayout__actions_btns OrderDetailsLayout__actions_btns--single_child"
    >
      <Button type="submit" isLoading={isLoading} variant="secondary">
        <FormattedMessage id="the_driver_was_informed" defaultMessage="The driver was informed" />
      </Button>
    </form>
  );
};

CancelDeliverOrder.propTypes = propTypes;
CancelDeliverOrder.defaultProps = defaultProps;

export default CancelDeliverOrder;



// WEBPACK FOOTER //
// ../ui-components/components/ActionButtons/CancelDeliverOrder.jsx